"use strict";

document.addEventListener('DOMContentLoaded', () => {
      document.querySelectorAll('.js-toggle').forEach(button => {
            button.addEventListener('click', () => {
                  const target = document.querySelector(
                        button.dataset.target
                  );
                  button.classList.toggle('is-open');
                  slideToggle(target);
            });
      });
});

function slideToggle(element, duration = 300) {
      element.style.transition = `height ${duration}ms ease`;
      element.style.overflow = 'hidden';

      if (element.offsetHeight === 0) {
            // 開く
            element.style.height = 'auto';
            const height = element.scrollHeight;
            element.style.height = '0px';
            requestAnimationFrame(() => {
                  element.style.height = height + 'px';
            });
            const end = () => {
                  element.style.height = 'auto';
                  element.removeEventListener('transitionend', end);
            };
            element.addEventListener('transitionend', end);
      } else {
            // 閉じる
            element.style.height = element.scrollHeight + 'px';
            requestAnimationFrame(() => {
                  element.style.height = '0px';
            });
      }
}